export default function HourGlassRoundIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15 18.75H9A1.752 1.752 0 017.25 17v-1.5a4.4 4.4 0 012.086-3.319.223.223 0 00.085-.181.22.22 0 00-.085-.18A4.408 4.408 0 017.25 8.5V7A1.752 1.752 0 019 5.25h6A1.752 1.752 0 0116.75 7v1.5a4.399 4.399 0 01-2.086 3.319.222.222 0 00-.085.181.22.22 0 00.085.18 4.408 4.408 0 012.086 3.32V17A1.752 1.752 0 0115 18.75zm-6-12a.25.25 0 00-.25.25v1.5a3.1 3.1 0 001.492 2.124 1.734 1.734 0 010 2.752A3.1 3.1 0 008.75 15.5V17a.25.25 0 00.25.25h6a.25.25 0 00.25-.25v-1.5a3.1 3.1 0 00-1.492-2.124 1.734 1.734 0 010-2.752A3.1 3.1 0 0015.25 8.5V7a.25.25 0 00-.25-.25H9z"
      />
      <path
        fill="currentColor"
        d="M12.021 22.752a10.861 10.861 0 01-1.446-.1.75.75 0 01-.55-1.12.74.74 0 01.75-.366A9.25 9.25 0 0018.48 5.399a.75.75 0 011.053-1.069 10.753 10.753 0 01-7.512 18.422zm-7.03-2.866a.752.752 0 01-.526-.215A10.762 10.762 0 015.472 3.458a10.665 10.665 0 017.952-2.113.75.75 0 11-.2 1.487 9.25 9.25 0 00-7.706 15.77.75.75 0 01-.527 1.284z"
      />
      <path
        fill="currentColor"
        d="M5.271 20.41a.697.697 0 01-.1-.006l-2.8-.375a.75.75 0 01.2-1.486l2.061.275.275-2.06a.74.74 0 01.843-.644.751.751 0 01.644.843l-.375 2.8a.75.75 0 01-.748.654zM18.356 7.893a.75.75 0 01-.744-.85l.375-2.8a.74.74 0 01.843-.643l2.8.375a.75.75 0 01-.2 1.486l-2.061-.275-.27 2.056a.75.75 0 01-.743.65z"
      />
    </svg>
  );
}
